import React from 'react';
import { Button, Typography, Tooltip } from '@mui/material';
import { IoPlay, IoPause } from "react-icons/io5";


const SFPauseCategory = ({ pausedCategoriesMap, currentCategoryKey,
    handlePauseCategory, handleResumeCategory, completedCategoryArray }) => {

    let isPaused = currentCategoryKey in pausedCategoriesMap;

    // if the category is mastered hide the pause button
    if (completedCategoryArray && completedCategoryArray.length && completedCategoryArray.includes(currentCategoryKey)) {
        return null
    }

    console.debug("completedCategoryArray>>>", completedCategoryArray)

    return (
        <div>
            {isPaused ? (
                <div className='d-none'>
                    <Typography>
                        Category is paused. 
                    </Typography>
                    <br/> 
                    <Typography>
                        Questions from this category will not be shown.
                        Please click "Next Question" to continue with other categories.
                    </Typography>
                    <br/> 
                    <Typography>
                        <strong>Note:</strong> Click the resume icon in the top category list to enable this category again.
                    </Typography>

                    <Button
                        hidden
                        variant='contained'
                        className='mt-4'
                        onClick={() => {
                            handleResumeCategory(currentCategoryKey)
                        }}
                        size='small'
                    >
                        Resume Category
                    </Button>
                </div>
            ) :
                (
                    <Tooltip placement="top" arrow title={
                        <Typography fontSize={12} color={"#fff"}>
                            You may choose to pause a category. Questions from a paused category will not be presented until the category is un-paused(resumed)
                        </Typography>
                    }>
                        <Button
                            variant={isPaused ? 'contained' : 'outlined'}
                            onClick={() => {
                                handlePauseCategory(null)
                            }}
                            size='small'
                        >
                            <IoPause fontSize={16} className='mr-1' />
                            Pause Category
                        </Button>
                    </Tooltip>
                )
            }
        </div>
    );
}

export default SFPauseCategory;
